export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-chocolate-lover-34b561c6be941d9711c80c4540fa9fc2.png";